"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validationFocus = exports.autoFocus = void 0;
var Label_scss_1 = __importDefault(require("./Label.scss"));
var labelClass = Label_scss_1.default['au-label'];
var fieldsetClass = Label_scss_1.default['au-fieldset'];
var errorClass = Label_scss_1.default['au-error-text'];
var autoFocus = function (container) {
    var label = document.querySelector("".concat(container, " .").concat(labelClass, ", ").concat(container, " .").concat(fieldsetClass));
    if (!label) {
        return;
    }
    var input;
    if (label.className.indexOf(labelClass) >= 0) {
        if (label.htmlFor) {
            input = document.querySelector("".concat(container, " #").concat(label.htmlFor));
        }
        else {
            input = null;
        }
    }
    else {
        input = label.querySelector('input');
    }
    if (input && input.focus) {
        input.focus();
    }
};
exports.autoFocus = autoFocus;
var validationFocus = function (container) {
    var errorText = document.querySelector("".concat(container, " .").concat(errorClass));
    if (!errorText) {
        return;
    }
    var input;
    var label = errorText.parentElement;
    if (label && label.className.indexOf(fieldsetClass) >= 0) {
        input = label.querySelector('input');
    }
    else {
        label = errorText.previousElementSibling;
        if (label && label.className.indexOf(labelClass) >= 0) {
            if (label.htmlFor) {
                input = document.querySelector("".concat(container, " #").concat(label.htmlFor));
            }
            else {
                input = null;
            }
        }
        else {
            input = null;
        }
    }
    if (input && input.focus) {
        input.focus();
    }
};
exports.validationFocus = validationFocus;
//# sourceMappingURL=Focus.js.map